import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DealsCarouselComponent } from './deals-carousel/deals-carousel.component';
import { LoyaltyCardModule } from 'abs-ngx-library/src/lib/loyalty-card';



@NgModule({
  declarations: [
    DealsCarouselComponent
  ],
  imports: [
    CommonModule,
    LoyaltyCardModule
  ],
  exports: [
    DealsCarouselComponent
  ]
})
export class DealsCarouselModule { }
